module.exports = __webpack_public_path__ + "static/media/TipSound.976cb93b.mp3";